module.exports = __webpack_public_path__ + "static/media/plus-icon.0034e33a.svg";